import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { upperFirst } from 'lodash';

import { useAppLayoutContext } from '@/components/app-layout/context';
import { useActiveForm } from '@/components/form/ActiveSwitch';
import FormWrapper from '@/components/form/Wrapper';
import { useAppAlert } from '@Components/AppAlert';
import history from '@Utils/history';
import routeStore from 'modules/cms/stores/route'
import appStore from 'stores/app';

import Form from '../components/Form';
import Heading from '../components/Heading';
import { PostProvider, usePostStore } from '../store';

function PostForm() {
  const { id, content_type: contentType } = useParams()

  const { collection: { data, useLoad, useSubmit, reset, version: { onChangeVersion } } } = usePostStore()

  const { setMenuCollapsed } = useAppLayoutContext()
  useEffect(() => {
    setMenuCollapsed(true)
  }, [setMenuCollapsed])

  const { handleSuccess, handleError } = useAppAlert()
  const key = data?.versionId || data?.id || ""

  const [currentTitle, setCurrentTitle] = useState("Title")
  const [sitePath, setSitePath] = useState("Title")

  const loadData = useLoad(id)
  const handleSubmit = useSubmit()
  const { active, setActive } = useActiveForm(data)
  console.log({active, data})

  useEffect(() => {
    !async function loadRoute() {
      const routes = await routeStore.all(appStore.site.id).then(res => res.data && res.data.rows);
      const post_id = data?.id
      const route = routes// && routes.filter(d=>d.content_type === 'page')
      .find(d => d.entity_id == post_id && d.content_type === contentType && d.entity === 'post')

      let sitePath = null
      if (route) {
        const url = new URL(`https://${appStore.site.domain}${route.path}`)
        if (process.env.NODE_ENV === 'development') {
          url.port = 3002
          url.protocol = 'http'
        }
        sitePath = url.href
      }

      setSitePath(sitePath)
    }()
  }, [data])

  const handleViewVersion = useCallback(version => {
    version.isDefault ? onChangeVersion(null) : onChangeVersion(version)
  }, [onChangeVersion])

  const handleSubmitAndRedirect = useCallback(async payload => {
    const title = upperFirst(contentType)
    try {
      const { id } = await handleSubmit({ ...payload, active })

      if (payload.id) {
        reset()
        await loadData(payload.id)
      } else {
        history.push(`./${id}`)
        reset()
      }

      const message = payload.id ? 'edited' : 'created'
      handleSuccess('Success', `${title} ${message}.`)
    } catch (error) {
      handleError('Error', `${title} was not saved.`)
    }
  }, [handleSubmit, reset, loadData, contentType, handleSuccess, handleError, active])

  return <FormWrapper title={upperFirst(contentType)}>
    <div key={key}>
      <Heading
        contentType={contentType}
        sitePath={sitePath}
        onView={handleViewVersion}
        currentTitle={currentTitle}
        active={active}
        onChangeActive={setActive}
      />
      <Form
        data={data}
        handleSubmit={handleSubmitAndRedirect}
        contentType={contentType}
        onChangeTitle={setCurrentTitle}
      />
    </div>
  </FormWrapper>
}

export default function PostFormLayout() {
  return <PostProvider>
    <PostForm />
  </PostProvider>
}
